const STEPS = {
    PERSONAL: 'personal',
    VALIDATE_IDENTITY: 'validateIdentity',
    HOME: 'home',
    EMPLOYMENT_DATA: 'employmentData',
    DESIRED_VEHICLE: 'desiredVehicle',
    INSURANCE: 'insurance',
    OTHER_REFERENCES: 'otherReferences',
    FAMILY_REFERENCES: 'familyReferences',
    OFFICE_REFERENCES: 'officeReferences',
    MARKETING_SOURCE: 'marketingSource',
    EXTRA_DATA: 'extraData',
    CALCULATOR: 'calculator',
    SIGNATURE: 'signature',
    ACCEPT_TERMS: 'acceptTerms',
    SUMMARY: 'summary',
    BUREAU: 'bureau',
    CREDIT_HISTORY: 'creditHistory',
};

const INPUTS = {
    FIRST_NAME: 'firstName',
    SECOND_NAME: 'secondName',
    LAST_NAME: 'lastName',
    SECOND_LAST_NAME: 'secondLastName',
    BIRTH_DATE: 'birthDate',
    DOC_NUMBER: 'docNumber',
    CELL_PHONE: 'cellPhone',
    EMAIL: 'email',
    GENDER: 'gender',
    ECONOMIC_DEPENDENTS: 'economicDependents',
    ALREADY_HAS_VEHICLES: 'alreadyHasVehicles',
    BUREAU_OPTION_CREDIT_CARD_LAST_DIGITS: 'bureauOptionCreditCardLastDigits',
    BUREAU_OPTION: 'bureauOption',
    INSURANCES: 'insurances',
    INCLUDE_INSURANCE: 'includeInsurance',
    INSURANCE_SELECTED: 'insuranceSelected',
    TARGET: 'target',
    INSURANCE_AMOUNT: 'insuranceAmount',
    INSURANCE_TYPE: 'insuranceType',
    COMPLETE_NAME: 'completeName',
    VEHICLE_PRICE: 'vehiclePrice',
    PHONE_TYPE: 'phoneType',
    CELLPHONE: 'cellphone',
    PHONE: 'phone',
    PHONE_EXT: 'phoneExt',
    CONTACT_TIME: 'contactTime',
    BRAND: 'brand',
    MODEL: 'model',
    VERSION: 'version',
    STATE: 'state',
    CIVIL_STATUS: 'civilStatus',
    AMOUNT_DEPENDENTS: 'amountDependents',
    CURP: 'curp',
    ROLE_HOME: 'roleHome',
    REGIME: 'regime',
    STUDIES: 'studies',
    HOME_TYPE: 'homeType',
    HOME_ROOT: 'homeRoot',
    HOME_ROOT_YEAR_MONTH: 'homeRootYear',
    YEAR: 'year',
    TERM: 'term',
    PRICE: 'price',
    DOWN_PAYMENT: 'downPayment',
    STEP: 'step',
    ADDRESS: 'address',
    EXT_NUMBER: 'extNumber',
    INT_NUMBER: 'intNumber',
    POSTAL_CODE: 'postalCode',
    OWNERSHIP: 'ownerShip',
    LIVING_SINCE: 'livingSince',
    NATIONALITY: 'nationality',
    CITY: 'city',
    MUNICIPALITY: 'municipality',
    COLONY: 'colony',
    SELECTED_COLONY: 'selectedColony',
    WORKPLACE_NAME: 'workplaceName',
    POSITION: 'position',
    WORKING_SINCE: 'workingSince',
    EXT: 'extNumber',
    INT: 'intNumber',
    WORKPLACE_PHONE: 'workplacePhone',
    WORKPLACE_PHONE_EXT: 'workplacePhoneExt',
    INCOME_MONTHLY: 'monthlyIncomes',
    CVE_CLICK: 'cveClick',
    SIGNATURE_POSITION: 'signaturePosition',
    SIGNATURE_IMAGE: 'signatureImage',
    AMOUNT_FINANCE: 'amountFinance',
    DETAIL_COMMISSION: 'detailCommission',
    MONTHLY_PAYMENT: 'monthlyPayment',
    MONTHLY_INSURANCE: 'monthlyInsurance',
    DESIRED_VEHICLE: 'desiredVehicle',
    VALIDATE_INCOME: 'validateIncome',
    NIP: 'nip',
    DOMICILE_ADDRESS: 'domicileAddress',
    DOMICILE_EXTERNAL_NUMBER: 'domicileExternalNumber',
    DOMICILE_INTERNAL_NUMBER: 'domicileInternalNumber',
    DOMICILE_POSTAL_CODE: 'domicilePostalCode',
    DOMICILE_STATE: 'domicileState',
    DOMICILE_CITY: 'domicileCity',
    DOMICILE_HOUSE_TYPE: 'domicileHouseType',
    EMPLOYMENT_VALIDATE_INCOMES: 'employmentInsurances',
    EMPLOYMENT_BILLING: 'employmentBilling',
    EMPLOYMENT_TAX_REGIME: 'employmentTaxRegime',
    EMPLOYMENT_BILLING_UPLOAD: 'employmentBillingUpload',
    EMPLOYMENT_TYPES: 'employmentTypes',
    EMPLOYMENT_COMPANY_NAME: 'employmentCompanyName',
    EMPLOYMENT_POSITION: 'employmentPosition',
    EMPLOYMENT_START_DATE: 'employmentStartDate',
    EMPLOYMENT_ADDRESS: 'employmentAddress',
    EMPLOYMENT_EXTERNAL_NUMBER: 'employmentExternalNumber',
    EMPLOYMENT_INTERNAL_NUMBER: 'employmentInternalNumber',
    EMPLOYMENT_POSTAL_CODE: 'employmentPostalCode',
    EMPLOYMENT_STATE: 'employmentState',
    EMPLOYMENT_CITY: 'employmentCity',
    EMPLOYMENT_MUNICIPALITY: 'employmentMunicipality',
    EMPLOYMENT_COLONY: 'employmentColony',
    EMPLOYMENT_PHONE: 'employmentPhone',
    EMPLOYMENT_PHONE_EXT: 'employmentPhoneExt',
    EMPLOYMENT_MONTHLY_INCOME: 'employmentMonthlyIncome',
    EMPLOYMENT_TURN: 'employmentTurn',
    EMPLOYMENT_STREET_BETWEEN: 'employmentStreetBetween',
    EMPLOYMENT_DOCUMENT_TYPE: 'employmentDocumentType',
    EMPLOYMENT_BUSINESS_TYPE: 'employmentBusinessType',
    DOMICILE_PHONE: 'domicilePhone'
};

const MX_VALUES = {
    COUNT_OTHERS_REFERENCES: 3,
    OFFICE: 'Oficina',
    HAVE_A_CREDIT_CARD: 'Tiene una tarjeta de crédito vigente',
    BOOLEAN_VALUES: [{
        id: 1, value: true, label: 'Si', payload: true
    }, {
        id: 2, value: false, label: 'No', payload: false
    }],
    MONTHLY_PAYMENTS: [
        {id: '12', value: 12, label: '12'},
        {id: '24', value: 24, label: '24'},
        {id: '36', value: 36, label: '36'},
        {id: '48', value: 48, label: '48'},
        {id: '60', value: 60, label: '60'},
    ]
};

export {
    STEPS,
    INPUTS,
    MX_VALUES
};
